import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';
import DocumentTitle from 'react-document-title';
import {searchQuestions, changeKeyword} from '../modules/Search';
import {getUser} from '../modules/Authenticate'; // eslint-disable-line
import Search from './Search';
import {emitPageView} from '../lib/mz'; // eslint-disable-line
import {showHome, showNewQuestion} from '../modules/Navigation';
import {setOrder} from '../modules/Questions';
import IntroPanel from './components/IntroPanel';
import SearchForm from './components/SearchForm';

@connect((state) => ({
  results: state.search.results,
  q: state.search.q,
  loading: state.search.loading,
  order: state.questions.order,
  user: state.authenticate.user,
  total: state.search.total,
  offset: state.search.offset,
  limit: state.search.limit,
  error: state.status.error,
  ready: state.status.ready,
  widget: state.environment.widget,
  widgetType: state.environment.widgetType,
  context: state.environment.widgetConfig.context,
  contextType: state.environment.widgetConfig.contextType,
}), (dispatch) => ({
  searchQuestions: (q, offset, contextType) => {
    dispatch(searchQuestions(q, offset, contextType));
  },
  searchClick: (q, contextType) => {
    dispatch(searchQuestions(q, 0, contextType));
  },
  showMoreClick: (q, offset, contextType) => {
    dispatch(searchQuestions(q, offset, contextType));
  },
  orderClick: (order, tag, context) => ((e) => {
    e.preventDefault();
    dispatch(setOrder(order, tag, context));
  }),
  showNewQuestionClick: (e) => {
    e.preventDefault();
    dispatch(showNewQuestion());
  },
  changeKeyword: (q) => {
    dispatch(changeKeyword(q));
  },
  showHomeClick: (widget, context, order) => (e) => {
    e.preventDefault();
    dispatch(showHome(widget, context, order));
  },
  getUser,
  searchSubmit: (q, contextType) => {
    dispatch(searchQuestions(q, 0, contextType));
  },
  onChangeKeyword: (q) => {
    dispatch(changeKeyword(q));
  },
}))
// eslint-disable-next-line react/prefer-stateless-function
export default class SearchContainer extends Component {
  static propTypes = {
    q: PropTypes.string,
    location: PropTypes.object,
    changeKeyword: PropTypes.func.isRequired,
    searchQuestions: PropTypes.func.isRequired,
    searchClick: PropTypes.func.isRequired,
    showHomeClick: PropTypes.func.isRequired,
    showNewQuestionClick: PropTypes.func.isRequired,
    showMoreClick: PropTypes.func.isRequired,
    orderClick: PropTypes.func.isRequired,
    getUser: PropTypes.func.isRequired,
    results: PropTypes.array,
    loading: PropTypes.bool.isRequired,
    tag: PropTypes.string,
    order: PropTypes.string,
    total: PropTypes.number,
    offset: PropTypes.number,
    limit: PropTypes.number,
    user: PropTypes.object,
    widget: PropTypes.bool.isRequired,
    widgetType: PropTypes.string.isRequired,
    contextType: PropTypes.string,
    context: PropTypes.string,
    searchSubmit: PropTypes.func.isRequired,
    onChangeKeyword: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.props.getUser();
    if (!this.props.results || !this.props.results.length) {
      const {location: {search}} = this.props;
      const query = search.replace(/\?/, '').split('&').reduce((p, c) => {
        const [k, v] = c.split('=');
        p[k] = v; // eslint-disable-line
        return p;
      }, {});
      this.props.searchQuestions(query.q, this.props.offset, this.props.contextType);
    }
  }

  render() {
    const {
      results,
      total,
      offset = 0,
      limit = 20,
      loading = false,
      user,
      order,
      orderClick,
      showHomeClick,
      showNewQuestionClick,
      showMoreClick,
      tag,
      widget,
      widgetType,
      q,
      searchSubmit,
      onChangeKeyword,
      context,
      contextType,
    } = this.props;

    const inactiveButtonClass = 'simple-tab__tab';

    const welcome = (
      <IntroPanel askQuestionClick={showNewQuestionClick}>
        {!widget &&
          [<div className="intro-panel__footer-child" key="onlyTemp1UntilWeMovetoInsideComponent">
            <div className="simple-tab" role="group">
              <button className={inactiveButtonClass} type="button" onClick={showHomeClick(widget, context, 'latest')}>
                Latest
              </button>
              <button className={inactiveButtonClass} type="button" onClick={showHomeClick(widget, context, 'latest')}>
                Views
              </button>
              <button className={inactiveButtonClass} type="button" onClick={showHomeClick(widget, context, 'latest')}>
                Votes
              </button>
            </div>
          </div>,
            <div className="intro-panel__footer-child" key="onlyTemp2UntilWeMovetoInsideComponent">
              <SearchForm q={q} contextType={contextType} searchSubmit={searchSubmit} changeKeyword={onChangeKeyword} widgetType={widgetType} />
            </div>,
          ] }
      </IntroPanel>
    );
    const search = (
      <Search
        q={this.props.q}
        changeKeyword={this.props.changeKeyword}
        searchClick={this.props.searchClick}
        showMoreClick={showMoreClick}
        questions={results}
        loadingQuestions={loading}
        order={order}
        tag={tag}
        offset={offset}
        limit={limit}
        total={total}
        orderClick={orderClick}
        user={user}
        showHomeClick={showHomeClick}
        widget={false}
        contextType={this.props.contextType}
      />
    );

    const title = 'Search Teacher Q&A';
    return (
      <DocumentTitle title={title}>
        <div>
          {welcome}
          <div className="l-app-padding">
            {search}
          </div>
        </div>
      </DocumentTitle>
    );
  }
}
